$(function(){
  /* @if env='production' **
  var SERVER = 'https://api-material.huariot.com/api-user/api/v1'
  /* @endif */
  /* @if env='testing' **
  var SERVER = 'http://test.portal.huariot.com/api-user/api/v1'
  /* @endif */
  /* @if env='development' **
  var SERVER = '/api-user/api/v1'
  /* @endif */  

  // 登录弹窗
  var logindialog = null
  var regdialog = null
	layui.use(['layer', 'element', 'form'], function(){
  	let layer = layui.layer
		let form = layui.form  
		let element = layui.element  
		
		form.on('submit(psdlogin)',function(data) {
      let params = $.extend({login_type: 1}, data.field)
			request({
        url: `${SERVER}/userlogin/login/`,
        data: params,
        type: 'POST'
      }).done(res => {        
        if (res.code === 0) {
          setToken(res.data.token)
          setUserData(res.data)
          layer.msg('登录成功,即将刷新当前页面')
          layer.close(logindialog)
          setTimeout(() => {
            location.reload()
          }, 2000)
        }
        else {
          layer.msg(res.message)          
        }
      })
    })  

    form.on('submit(maillogin)', function(data) {
      let serial_number = $('#loginmail').data('serialNumber')
      let params = $.extend({ 
        login_type: 2,
        serial_number }, data.field)
      request({
        url: `${SERVER}/userlogin/login/`,
        data: params,
        type: 'POST'
      }).done(res => {        
        if (res.code === 0) {
          setToken(res.data.token)
          setUserData(res.data)
          layer.msg('登录成功,即将刷新当前页面')
          layer.close(logindialog)
          setTimeout(() => {
            location.reload()
          }, 2000)
        }
        else {
          layer.msg(res.message)          
        }
      })
      return false
    })

    form.on('submit(personReg)', function(data) {
      if (!data.field.isAgree) {
        layer.msg('请同意用户使用协议')
        return 
      }
      let serial_number = $('#regPersonMail').data('serialNumber')
      let params = $.extend({ serial_number }, data.field)      
      delete params.isAgree        
      request({
        url: `${SERVER}/register/person/`,
        data: params,
        type: 'POST'        
      }).done(res => {
        if (res.code === 0) {
          setToken(res.data.token)
          setUserData(res.data)
          layer.msg('注册成功,即将刷新当前页面')
          layer.close(regdialog)
          setTimeout(() => {
            location.reload()
          }, 2000)
        }
        else {
          layer.msg(res.message)          
        }
      })
    })


    form.verify({
      thesame: function(value, item) {
        if (value != $('#newpassword').val()) {
          return '两次输入的密码不一致'
        }
      }
    })    
    form.on('submit(companyReg)', function(data) {      
      if (!data.field.isAgree) {
        layer.msg('请同意用户使用协议')
        return 
      }      
      let serial_number = $('#regCompanyMail').data('serialNumber')
      let params = $.extend({ serial_number }, data.field)      
      delete params.isAgree          
      delete params.confirmPsd
      request({
        url: `${SERVER}/register/company/`,
        data: params,
        type: 'POST'        
      }).done(res => {
        if (res.code === 0) {
          setToken(res.data.token)
          setUserData(res.data)
          layer.msg('注册成功,即将刷新当前页面')
          layer.close(regdialog)
          setTimeout(() => {
            location.reload()
          }, 2000)
        }
        else {
          layer.msg(res.message)          
        }
      })
    })
  })
  
  
	$('#login').on('click', () => {
		logindialog = layer.open({
			type: 1,
			title: false,
			area: '440px',
			content: $('#dialogLogin')
		})		
  })
  
  $('#reg').on('click', () => {
    regdialog = layer.open({
      type: 1,
      title: false,
      area: '440px',
      content: $('#dialogReg')
    })
  })


  $('#loginmail').on('click', function() {
    getSMS($('#loginphone'), $(this))
  })

  $('#regPersonMail').on('click', function() {
    getSMS($('#regPersonPhone'), $(this))
  })

  $('#regCompanyMail').on('click', function() {
    getSMS($('#regCompanyPhone'), $(this))
  })

  /**
   * ajax请求
   * @param {String} url 请求地址
   * @param {Object} data 参数
   * @param {String} type 类型
   */
  function request({
    url,
    data,
    type
  }) {
    var token = getToken()
    return $.ajax({
      url: url,
      type: type,
      data: type === 'POST' ? JSON.stringify(data) : data,
      contentType: "application/json;charset=utf-8",
      beforeSend: res => {
        if (token) {
          res.setRequestHeader("Authorization", token);
        }
      },
      dataType: 'json'
    })
  }  

  /**
   * 短信验证码
   * @param {[dom]} phoneDom 手机号输入
   * @param {[dom]} 按钮dom 
   */
  function getSMS(phoneDom, btn) {
    let phone = $(phoneDom).val()
    let flag = /^1[34578]\d{9}$/.test(phone)
    if (!flag) {
      layer.msg('手机号码格式不正确')
      return
    } else {
      request({
        url: `${SERVER}/userlogin/sms/`,
        data: { phoneNumber: phone },
        type: 'GET'
      }).done(res => {
        stopsend(btn)
        console.log(res.data.serial_number)
        btn.data('serialNumber', res.data.serial_number)
      })
    }
  } 

  //发送验证码等待时间
  function stopsend(ele) {
    $(ele).attr('disabled', "true")
    $(ele).addClass('layui-btn-disabled')
    var time = 60
    var timer = setInterval(function () {
      if (time-- == 1) {
        $(ele).removeAttr("disabled")
        $(ele).removeClass("layui-btn-disabled")
        clearInterval(timer)
      }
      $(ele).html(time == 0 ? '获取验证码' : time + 's')
    }, 1000)
  }



  //设置token
  function setToken(token) {
    // var time = new Date()
    // time.setTime(time.getTime() + 60 * 1000) 
    CookieUtil.set('hwUserToken', token)
  }  
  // 设置用户基本信息
  function setUserData(data) {
    CookieUtil.set('hwUserData', JSON.stringify(data))
  }
  // 获取token
  function getToken() {
    return CookieUtil.get('hwUserToken')
  }  

  // 设置header
  function setpageHead() {
    var userData=null
    var token = getToken()
    if(token) {
      userData = JSON.parse(CookieUtil.get('hwUserData'))
      $('header').addClass('haslogined')
      $('.logined-username span').html(userData.user_name|| userData.access_key)
    }
  }
  setpageHead()

  $('#logout').on('click',function(){
		CookieUtil.unset('hwUserToken')
		CookieUtil.unset('hwUserData')
		location.href = '/'
	})	
})